var obj = {
  s: '',
  d: '',
  se: '',
  dsdtse: '',
  t: '4043',
  b: '',
  dfa: '',
  vdfa: ''
};
export default obj;